import { render, staticRenderFns } from "./main_questions.vue?vue&type=template&id=65a44a3d&scoped=true&"
import script from "./main_questions.vue?vue&type=script&lang=js&"
export * from "./main_questions.vue?vue&type=script&lang=js&"
import style0 from "./main_questions.vue?vue&type=style&index=0&id=65a44a3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a44a3d",
  null
  
)

export default component.exports